module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_sns_05-5a352d21cb3377b20086f6b224f69b2f.jpg";